export type RouteHandler = () => void | Promise<void>;

const routes = new Map<string, RouteHandler>();

export function route(path: string, handler: RouteHandler): void {
  routes.set(path, handler);
}

export function navigate(path: string, replace = false): void {
  if (replace) {
    history.replaceState({}, "", path);
  } else {
    history.pushState({}, "", path);
  }
  renderRoute();
}

export function currentPath(): string {
  return location.pathname.replace(/\/$/, "") || "/";
}

export function renderRoute(): void {
  const path = currentPath();
  const handler = routes.get(path) ?? routes.get("*");
  if (handler) void handler();
  window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" as ScrollBehavior : "auto" });
  document.dispatchEvent(new CustomEvent("cg:route", { detail: { path } }));
}

export function startRouter(): void {
  document.body.addEventListener("click", (e) => {
    const t = e.target as HTMLElement | null;
    const a = t?.closest?.("a[href]") as HTMLAnchorElement | null;
    if (!a) return;
    const href = a.getAttribute("href");
    if (!href || href.startsWith("http") || href.startsWith("mailto:") || href.startsWith("#")) return;
    if (a.target === "_blank" || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    navigate(href);
  });

  window.addEventListener("popstate", () => renderRoute());
  renderRoute();
}
